import { Region, RegionConfig, Urls } from "../abstractions/environment.service";

/** The only server supported by the MavenInject clients. */
export const MAVENINJECT_SERVER_URL = "https://maveninject.mavenepm.com";

/**
 * Return a fresh URL map for the MavenInject server.
 *
 * The environment service normalizes and mutates URL maps while persisting them,
 * so callers must not share one mutable object between state and runtime code.
 */
export function getMavenInjectServerUrls(): Urls {
  return {
    base: MAVENINJECT_SERVER_URL,
    webVault: MAVENINJECT_SERVER_URL,
  };
}

/** Configuration used by environment-aware client code. */
export const MAVENINJECT_REGION_CONFIG: RegionConfig = {
  key: Region.SelfHosted,
  domain: "maveninject.mavenepm.com",
  urls: getMavenInjectServerUrls(),
};
